import { useEffect, useState } from 'react';
import { css } from '@eti/styles';
import { price as priceUtils } from '@eti/utils';
import ProductLayout from '../../common/main-layout/ProductLayout';
import { CABIN_UPGRADE } from '../../products';
import { getCabinUpgradeProduct, getSegmentUpgrade, minimumSegmentUpgradeTotalPrice, selectedSegmentUpgradeTotalPrice } from '../utils/utils';
import { useProductData } from '../../common/hook/useProductData';
import CabinUpgradeDrawer from './drawer/CabinUpgradeDrawer';
import ChangeUpgradeSelection from './ChangeUpgradeSelection';
import CabinUpgradeAvailabilityCard from './CabinUpgradeAvailabilityCard';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = CABIN_UPGRADE;
const generalTexts = {
  abstractContent: 'cabinUpgradeAbstract',
  additionalInformation: 'cabinUpgradeAdditionalInformation',
  availabilityCardAvailabilityTitle: 'cabinUpgradeAvailabilityCardAvailabilityTitle',
  availabilityCardAvailableStatus: 'cabinUpgradeAvailabilityCardAvailableStatus',
  availabilityCardChangeUpgradeLabel: 'cabinUpgradeAvailabilityCardChangeUpgradeLabel',
  availabilityCardStatusTooltip: 'cabinUpgradeAvailabilityCardStatusTooltip',
  availabilityCardUnavailableStatus: 'cabinUpgradeAvailabilityCardUnavailableStatus',
  drawerCheckboxSelectionLabel: 'cabinUpgradeDrawerCheckboxSelectionLabel',
  drawerAdditionalContentText: 'cabinUpgradeDrawerAdditionalContentText',
  drawerCardFlightDuration: 'cabinUpgradeDrawerCardFlightDuration',
  drawerCardSelectionTitle: 'cabinUpgradeDrawerCardSelectionTitle',
  drawerSaveButtonLabel: 'cabinUpgradeDrawerSaveButtonLabel',
  drawerTitle: 'cabinUpgradeDrawerTitle',
  drawerTotalPriceLabel: 'cabinUpgradeDrawerTotalPriceLabel',
  drawerPerPersonLabel: 'cabinUpgradeDrawerPerPersonLabel',
  drawerPerksPremiumEconomyUpgradeType: 'cabinUpgradeDrawerPerksPremiumEconomyUpgradeType',
  drawerPerksPremiumEconomyAvailablePerks: 'cabinUpgradeDrawerPerksPremiumEconomyAvailablePerks',
  drawerPerksBusinessUpgradeType: 'cabinUpgradeDrawerPerksBusinessUpgradeType',
  drawerPerksBusinessAvailablePerks: 'cabinUpgradeDrawerPerksBusinessAvailablePerks',
  drawerPerksFirstClassUpgradeType: 'cabinUpgradeDrawerPerksFirstClassUpgradeType',
  drawerPerksFirstClassAvailablePerks: 'cabinUpgradeDrawerPerksFirstClassAvailablePerks',
  fromPriceLabel: 'Products.Price.Label.From',
  destinationLabel: 'Searchform.Destination.Label',
  readMoreContent: 'cabinUpgradeReadMoreModalContent',
  title: 'cabinUpgradeTitle',
  totalPriceLabel: 'Products.Price.Label.Total',
  upSell: 'cabinUpgradeUpsell'
};
const readMoreGrid = css`
  display: grid;

  .text {
    grid-area: 2 / 1 / 3 / 2;
  }

  .children {
    display: grid;
    grid-area: 1 / 1 / 2 / 2;
    margin-bottom: 16px;
    padding-inline: 16px;
  }
`;
const CabinUpgrade = ({
  form,
  isPostBooking,
  isProductSelected,
  isUpgradeSaved,
  order,
  productPosition,
  selectedUpgrades,
  unselectedUpgrades,
  updateSelectedCabinUpgrades
}) => {
  var _selectedSegmentUpgra, _minimumSegmentUpgrad;
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const texts = generalTexts || {};
  const product = getCabinUpgradeProduct(PRODUCT_ID, order);
  const {
    productData,
    rootElement,
    translation
  } = useProductData({
    form,
    isSelected: isUpgradeSaved,
    order: order,
    productId: PRODUCT_ID,
    productName: PRODUCT_NAME,
    productPosition,
    texts
  });
  useEffect(() => {
    if (isProductSelected) {
      setIsDrawerOpen(isProductSelected);
    }
  }, [isProductSelected]);
  const segmentUpgradeList = product ? getSegmentUpgrade(product, order) : [];
  const shouldHideCabinUpgrade = !productData || !isPostBooking || !(segmentUpgradeList !== null && segmentUpgradeList !== void 0 && segmentUpgradeList.length);
  if (shouldHideCabinUpgrade) {
    return null;
  }
  const priceRaw = isUpgradeSaved ? (_selectedSegmentUpgra = selectedSegmentUpgradeTotalPrice(selectedUpgrades)) !== null && _selectedSegmentUpgra !== void 0 ? _selectedSegmentUpgra : 0 : (_minimumSegmentUpgrad = minimumSegmentUpgradeTotalPrice(segmentUpgradeList)) !== null && _minimumSegmentUpgrad !== void 0 ? _minimumSegmentUpgrad : 0;
  const {
    availabilityCardAvailabilityTitle,
    availabilityCardAvailableStatus,
    availabilityCardChangeUpgradeLabel,
    availabilityCardStatusTooltip,
    availabilityCardUnavailableStatus,
    drawerCheckboxSelectionLabel,
    drawerAdditionalContentText,
    drawerCardFlightDuration,
    drawerCardSelectionTitle,
    drawerSaveButtonLabel,
    drawerTitle,
    drawerTotalPriceLabel,
    drawerPerPersonLabel,
    drawerPerksPremiumEconomyUpgradeType,
    drawerPerksPremiumEconomyAvailablePerks,
    drawerPerksBusinessUpgradeType,
    drawerPerksBusinessAvailablePerks,
    drawerPerksFirstClassUpgradeType,
    drawerPerksFirstClassAvailablePerks,
    destinationLabel,
    fromPriceLabel,
    totalPriceLabel
  } = translation;
  const updatedProductData = {
    ...productData,
    priceRaw,
    price: priceUtils.formatPrice(priceRaw),
    priceLabel: isUpgradeSaved ? totalPriceLabel : fromPriceLabel
  };
  return /*#__PURE__*/_jsxs(ProductLayout, {
    productData: updatedProductData,
    ref: rootElement,
    children: [/*#__PURE__*/_jsx(ProductLayout.ReadMore, {
      customGrid: readMoreGrid,
      children: /*#__PURE__*/_jsx(CabinUpgradeAvailabilityCard, {
        availabilityCardTexts: {
          availabilityCardAvailabilityTitle,
          availabilityCardAvailableStatus,
          availabilityCardUnavailableStatus,
          availabilityCardStatusTooltip
        },
        destinationLabel: destinationLabel,
        segmentUpgradeList: segmentUpgradeList
      })
    }), /*#__PURE__*/_jsx(CabinUpgradeDrawer, {
      availabilityTexts: {
        availabilityCardAvailabilityTitle,
        availabilityCardAvailableStatus,
        availabilityCardStatusTooltip,
        availabilityCardUnavailableStatus,
        drawerCheckboxSelectionLabel,
        drawerAdditionalContentText,
        drawerCardFlightDuration,
        drawerCardSelectionTitle,
        drawerSaveButtonLabel,
        drawerTitle,
        drawerTotalPriceLabel,
        drawerPerPersonLabel,
        drawerPerksPremiumEconomyUpgradeType,
        drawerPerksPremiumEconomyAvailablePerks,
        drawerPerksBusinessUpgradeType,
        drawerPerksBusinessAvailablePerks,
        drawerPerksFirstClassUpgradeType,
        drawerPerksFirstClassAvailablePerks,
        destinationLabel
      },
      isOpen: isDrawerOpen,
      isProductSelected: isProductSelected,
      isUpgradeSaved: isUpgradeSaved,
      segmentUpgradeList: segmentUpgradeList,
      selectedUpgrades: selectedUpgrades,
      setIsDrawerOpen: setIsDrawerOpen,
      unselectedUpgrades: unselectedUpgrades,
      updateSelectedCabinUpgrades: updateSelectedCabinUpgrades
    }), isUpgradeSaved && /*#__PURE__*/_jsx(ChangeUpgradeSelection, {
      label: availabilityCardChangeUpgradeLabel,
      setIsDrawerOpen: setIsDrawerOpen
    })]
  });
};
export default CabinUpgrade;
//# sourceMappingURL=CabinUpgrade.js.map